import React from 'react';
import {
    Carousel as MaestroCarousel,
    useBreakpoint,
    Box,
} from '@landr/maestro';
import { Pack, Repack } from 'types/generated/graphql';
import Wrapper from 'components/CommonUi/Wrapper';
import { usePreviewContext } from '../contexts/PreviewContext/PreviewContext';
import Slide from './Slide';
import { SlideSkeleton } from './Slide';

const _Carousel = ({
    slides,
    isMobile,
}: {
    slides: JSX.Element[];
    isMobile: boolean;
}) => {
    return (
        <Wrapper isNegative={true}>
            <MaestroCarousel
                items={slides}
                slidesPerPage={{
                    xs: 2,
                    sm: 3,
                    md: 4,
                    lg: 5,
                    xl: 6,
                    default: 6,
                }}
                scrollToSelection={false}
                gutter="md"
                itemsOffset={isMobile ? 'xl' : undefined}
                minHeight={isMobile ? '220px' : '280px'}
                arrowOffset="4xl"
            />
        </Wrapper>
    );
};

const useCarousel = ({
    items,
    isLoading,
}: {
    items: Pack[] | Repack[];
    isLoading: boolean;
}) => {
    let slides: JSX.Element[];

    if (!isLoading) {
        slides = items.map((item) => {
            return <Slide key={item?.name} item={item} />;
        });
    } else {
        slides = [
            <SlideSkeleton key="slide-skeleton-1" />,
            <SlideSkeleton key="slide-skeleton-2" />,
            <SlideSkeleton key="slide-skeleton-3" />,
            <SlideSkeleton key="slide-skeleton-4" />,
            <SlideSkeleton key="slide-skeleton-5" />,
            <SlideSkeleton key="slide-skeleton-6" />,
        ];
    }

    return { slides };
};

const Carousel = ({
    items = [],
    isLoading = false,
}: {
    items?: Pack[] | Repack[];
    isLoading?: boolean;
}) => {
    const isMobile = useBreakpoint('md');
    const { slides } = useCarousel({ items, isLoading });
    const { parentRef } = usePreviewContext();

    return (
        <Box ref={parentRef} position="relative">
            <_Carousel slides={slides} isMobile={isMobile} />
        </Box>
    );
};

export default Carousel;
